export const DEFAULT_MEMORY_LOGGING_THRESHOLDS = {
  listenerCount: 60000,
  timerCount: 550,
  observerCount: 2500
};
export function resolveMemoryLoggingThresholds(config) {
  if (config === undefined) return undefined;
  if (config === true) return DEFAULT_MEMORY_LOGGING_THRESHOLDS;
  return config;
}